import React from "react";
import Menu from "../../../../../common/element/Menu";
import { NavLink } from "react-router-dom";
const AdminMenu = () => {
  const handleToggle = (expanded, e) => { };

  return (
    <div className="" style={{ maxWidth: 176 }}>
      <Menu>
        <Menu.MenuItem eventKey="item-1">
          <NavLink to="dashboard">Dashboard</NavLink>
        </Menu.MenuItem>
        {/* All User */}
        <Menu.MenuCollapse
          eventKey="item-2"
          label="Users"
          onToggle={handleToggle}

        >
          <Menu.MenuItem eventKey="item-2-1" className="ml-3 ">
            <NavLink to="users" className="nav-link">All Users</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-2-2" className="ml-3">
            <NavLink to="notifications" className="nav-link">Notifications</NavLink>{" "}
          </Menu.MenuItem>
        </Menu.MenuCollapse>
        <Menu.MenuCollapse
          eventKey="item-3"
          label="System Config"
          onToggle={handleToggle}
        >
          <Menu.MenuItem eventKey="item-3-0" className="ml-3">
            <NavLink to="doc-categories" className="nav-link">Doc Categories</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-1" className="ml-3">
            <NavLink to="doc-type" className="nav-link">Doc Types</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-2" className="ml-3">
            <NavLink to="services-types" className="nav-link">Service Types</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-4" className="ml-3">
            <NavLink to="provider-types" className="nav-link">Provider Types</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-3" className="ml-3">
            <NavLink to="email-templates" className="nav-link">Email Templates</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-5" className="ml-3">
            <NavLink to="notification-emails" className="nav-link">Notifications</NavLink>{" "}
          </Menu.MenuItem>
          {/* <Menu.MenuItem eventKey="item-3-">
            <NavLink to="item-two">Payment Tiers</NavLink>{" "}
          </Menu.MenuItem> */}
        </Menu.MenuCollapse>
        <Menu.MenuCollapse
          eventKey="item-4"
          label="System Logs"
          onToggle={handleToggle}
        >
          <Menu.MenuItem eventKey="item-3-1" className="ml-3">
            <NavLink to="audit-log" className="nav-link">Audit Log</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-2" className="ml-3">
            <NavLink to="email-log" className="nav-link">Email Log</NavLink>{" "}
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3-3" className="ml-3">
            <NavLink to="email-audit-log" className="nav-link">System Email Log</NavLink>{" "}
          </Menu.MenuItem>
        </Menu.MenuCollapse>
        <Menu.MenuItem eventKey="item-5">
          <NavLink to="invoices">Invoices</NavLink>
        </Menu.MenuItem>
        <Menu.MenuItem eventKey="item-6">
          <NavLink to="reports">Reports</NavLink>
        </Menu.MenuItem>
      </Menu>
    </div>
  );
};

export default AdminMenu;
